import styled from 'styled-components';
import {
  Image as SemanticImage,
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ChartContainer = styled.div`
  width: 100%;
  height: 500px;
`;

export const TickContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ViewImageLink = styled.p`
  cursor: pointer;
  color: #007bff;
`;

export const Modal = styled(SemanticModal)`
  height: 100vh;
  width: 100vw;
  &.ui.modal {
    height: 70%;
    width: 70%;
    max-width: 1345px;
    max-height: 700px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 3%;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 80%;
`;

export const ModalImage = styled(SemanticImage)`
  max-width: 100%;
  max-height: 100%;
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.color.link};
  text-decoration: none;
  cursor: pointer;
  font-weight: 400;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 22px 0;
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`;

export const Title = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
  margin-top: 20px;
`;

export const QuestionOrder = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
`;

export const ContainerLabels = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
`;

export const WatchQuestionLink = styled.a`
  font-weight: 500;
`;

export const QuestionTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 20px;
`;
